export const resumeProfile = {
  name: "André Moura Passos Florentino",
  profileUrl: "https://andremourapassos.com",
  role: "Desenvolvedor Full Stack Senior",
  contacts: [
    { label: "E-mail", value: "andremourapassos@gmail.com", href: "mailto:andremourapassos@gmail.com" },
    { label: "Telefone", value: "+55 (11) 97661-5406", href: "tel:+5511976615406" },
    { label: "Site", value: "andremourapassos.com", href: "https://andremourapassos.com" },
    {
      label: "LinkedIn",
      value: "linkedin.com/in/andremourapassos",
      href: "https://www.linkedin.com/in/andremourapassos",
    },
  ],
  summaryParagraphs: [
    "Desenvolvedor full-stack com 14 anos de experiencia no desenvolvimento de aplicacoes, com forte atuacao em engenharia de backend nos ecossistemas PHP e JavaScript, especialmente Magento, Laravel e Node.js. React e frontend entram como apoio estrategico quando necessario para garantir a entrega ponta a ponta.",
    "Experiencia consolidada em plataformas de e-commerce, sistemas de pagamento e solucoes SaaS B2B e B2C. Atua com foco em logica de negocio, modelagem de dominio e arquitetura em nivel de aplicacao, conduzindo regras complexas, fluxos transacionais e integracoes seguras com foco em confiabilidade, performance e clareza tecnica.",
    "Atuacao recorrente em refatoracao e modernizacao de sistemas legados para melhorar manutencao e escalabilidade sem interromper operacoes em producao. Trabalha de forma proxima a times de DevOps e infraestrutura para garantir deploys estaveis, observabilidade e qualidade continua de codigo.",
    "Nos trabalhos recentes, integrou servicos de IA em ambientes Magento, Laravel e Node, criando servicos controlados de geracao de conteudo e camadas de validacao baseadas em algoritmos de precisao para requisitos regulatorios e de negocio. O fluxo de desenvolvimento inclui uso tecnico de ferramentas assistidas por IA, como Codex e Claude, para acelerar prototipagem e entregas sem perder governanca de implementacao.",
  ],
  highlights: [
    "Backend: PHP, Laravel, Node.js",
    "Frontend: React, HTML5, CSS3, Tailwind",
    "Arquitetura: Clean, DDD, SOLID, MVC, microsservicos",
    "Dados e Infra: MySQL, PostgreSQL, Docker, CI/CD, Redis, RabbitMQ",
    "IA aplicada: OpenAI APIs, Codex, Claude, prompt engineering",
  ],
  recentExperience: [
    "PicPay / Grupo Multicap | Fullstack Senior | 09/2025 - Atual",
    "ICTS | Fullstack Senior | 03/2025 - 08/2025",
    "RD Saude / Go-K | Backend Senior | 02/2022 - 01/2025",
    "Grupo FCamara | Full Stack Senior | 11/2020 - 01/2022",
  ],
  experienceTimeline: [
    {
      id: "soul_marketing",
      company: "Soul Marketing",
      role: "Desenvolvedor PHP",
      start: "2012-05",
      end: "2013-05",
      details: [
        "Desenvolveu solucoes de e-commerce baseadas em Magento.",
        "Personalizou modulos e temas do Magento.",
      ],
    },
    {
      id: "smart_ecommerce",
      company: "Smart e-Commerce do Brasil",
      role: "Desenvolvedor Magento",
      start: "2013-06",
      end: "2014-06",
      details: [
        "Desenvolveu e personalizou solucoes fullstack em Magento e PHP.",
        "Implementou integracoes de APIs de terceiros com Magento.",
      ],
    },
    {
      id: "pivot_enxame",
      company: "Pivot Produtora / Enxame",
      role: "Desenvolvedor Senior PHP",
      start: "2014-06",
      end: "2015-07",
      details: [
        "Desenvolveu e manteve projetos de e-commerce.",
        "Utilizou Magento, WordPress, Laravel e PHP para customizacoes.",
        "Personalizou temas, plugins e interfaces frontend.",
      ],
    },
    {
      id: "tagweb",
      company: "TagWeb",
      role: "Desenvolvedor Freelancer",
      start: "2015-07",
      end: "2020-11",
      details: [
        "Desenvolveu solucoes full-stack com PHP, Magento e Laravel.",
        "Trabalhou com Zend, Symfony, WordPress, React e JavaScript.",
        "Criou e manteve APIs REST.",
      ],
    },
    {
      id: "grupo_fcamara",
      company: "Grupo FCamara",
      role: "Desenvolvedor Full Stack Senior",
      start: "2020-11",
      end: "2022-01",
      details: [
        "Desenvolveu e manteve modulos para Magento 2.",
        "Criou e personalizou APIs REST/SOAP para ERP e pagamentos.",
        "Automatizou pipelines de CI/CD utilizando Magento Cloud.",
        "Aplicou TDD e metodologias ageis (Scrum, Kanban).",
        "Redigiu documentacao tecnica para customizacoes.",
      ],
    },
    {
      id: "rd_saude_go_k",
      company: "RD Saude / Go-K",
      role: "Desenvolvedor Backend Senior",
      start: "2022-02",
      end: "2025-01",
      details: [
        "Desenvolveu e personalizou modulos para Magento 2 e Laravel.",
        "Criou microsservicos e integrou Node.js, Next.js e OpenAI.",
        "Ajustou e treinou Modelos de Linguagem de Grande Escala (LLMs).",
        "Desenvolveu frontend/backend para treinamento de LLMs e engenharia de prompts.",
        "Automatizou o processamento de documentos com parsing de PDFs.",
        "Utilizou IA generativa para reduzir o esforco manual em 80%.",
        "Aplicou TDD no Magento 2 e Laravel.",
        "Implementou APIs RESTful e seguiu metodologias ageis (Scrum/Kanban).",
        "Criou documentacao tecnica e manuais de usuario.",
      ],
    },
    {
      id: "icts",
      company: "ICTS",
      role: "Desenvolvedor Fullstack Senior",
      start: "2025-03",
      end: "2025-08",
      details: [
        "Desenvolveu e manteve funcionalidades em Laravel em diversos projetos.",
        "Criou e atualizou migrations, seeders e relacionamentos Eloquent.",
        "Integrou APIs externas e realizou transformacoes em dados JSON.",
        "Desenvolveu e manteve aplicacoes Laravel com integracao de IA conversacional.",
        "Criou e aperfeicoou fluxos de chat em multiplos niveis com filtros, paginacao e respostas.",
        "Prestou suporte e manutencao por meio de depuracao, onboarding e reunioes com clientes.",
        "Colaborou com equipes multidisciplinares para definir e entregar novas funcionalidades.",
        "Elaborou documentacao sobre configuracao, implementacao, desempenho e boas praticas de seguranca.",
        "Criou documentacoes tecnicas com IA e desenvolveu um agente interno para automatizar essas documentacoes.",
      ],
    },
    {
      id: "multicap",
      company: "PicPay / Grupo Multicap",
      role: "Desenvolvedor Fullstack Senior",
      start: "2025-09",
      end: "present",
      details: [
        "Desenvolveu servicos backend em Laravel aplicando Clean Architecture, DDD e SOLID.",
        "Desenvolveu servicos e webhooks em PHP puro com SOLID, DDD e Clean Architecture.",
        "Modelou dominios financeiros complexos com entidades, value objects, eventos de dominio e abstracoes de repositorio.",
        "Desenvolveu APIs RESTful com casos de uso orientados a DTOs e respostas em Resources.",
        "Integrou sistemas internos com gateways de pagamento e plataformas ERP para automacao.",
        "Escreveu testes unitarios e de integracao para validar logica de dominio e fluxos de API.",
        "Aplicou analise estatica e padroes de codigo para garantir manutenibilidade e qualidade.",
        "Prestou suporte no rollout em producao com debug, validacoes e estabilizacao do sistema.",
        "Utilizou ferramentas de IA para apoio a documentacao, analises e geracao de insights.",
      ],
    },
  ],
  education: [
    "FATEC - Tecnologia em Gestao Empresarial (2011)",
    "Senac - Pos-Graduacao em Gestao Web (2013)",
  ],
  languages: ["Ingles: avancado", "Espanhol: intermediario"],
};
